<template>
  <Page>
    <div class="h-screen flex">
      <div class="m-auto">
        <div class="flex-col justify-start items-center gap-4 flex">
          <div
            class="px-4 py-2 bg-orange-100 rounded-lg justify-center items-start gap-[5px] inline-flex"
          >
            <div
              class="w-6 h-6 relative flex-col justify-start items-start inline-flex"
            >
              <svg
                class="w-6 h-6 text-orange-600"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <path
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M12 14v3m-3-6V7a3 3 0 1 1 6 0v4m-8 0h10a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1Z"
                />
              </svg>
            </div>
            <div
              class="text-center text-orange-600 text-lg font-medium leading-[27px]"
            >
              Restricted
            </div>
          </div>
          <div
            class="text-center text-gray-900 text-4xl font-normal leading-[54px]"
          >
            You don't have permission to access this page
          </div>
        </div>

        <div class="flex-col justify-start items-center gap-6 flex">
          <div class="text-center text-gray-500 text-sm">
            Reach out to your system admin to gain access or if you believe this
            is an error.
          </div>
          <div
            class="self-stretch justify-center items-start gap-4 inline-flex"
          >
            <sera-button label="Go back" @click="goBack"></sera-button>
          </div>
        </div>
      </div>
    </div>
  </Page>
</template>

<script setup lang="ts">
import { useRouter } from "vue-router";

import Page from "@/components/Page.vue";

const router = useRouter();

const goBack = () => {
  router.back();
};
</script>
